import { useRef, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';

export const PromoVideo = () => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    const v = ref.current;
    v.muted = !muted;
    if (!v.muted) v.play();
    setMuted(v.muted);
  };

  return (
    <div className="relative">
      <video
        ref={ref}
        data-testid="demo-video"
        className="w-full aspect-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster="/video-poster-v2d.webp"
      >
        <source src="/petflycheck-promo-v2d.mp4" type="video/mp4" />
      </video>
      <button
        type="button"
        data-testid="demo-video-sound-toggle"
        onClick={toggleSound}
        aria-label={muted ? 'Turn sound on' : 'Mute'}
        className="absolute bottom-3 right-3 flex items-center gap-2 rounded-full bg-slate-900/70 px-3 py-2 text-xs font-medium text-white backdrop-blur transition-colors hover:bg-slate-900/90"
      >
        {muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
        {muted ? 'Sound on' : 'Mute'}
      </button>
    </div>
  );
};

export default PromoVideo;
